import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	filtersHelperText: {
		id: 'software.reports.cycle-time-breakdown-report.src.ui.filters.a11y-helper',
		defaultMessage:
			'On selecting any checkboxes from the Type and Epic filters, the below content will get updated',
		description: 'Additional context for accessibility',
	},
});
